import React from "react";
import { DataDisplayRecord } from "components/data-display";
import { GridLayout } from "components/grid/GridLayout";
import { ShowHide } from "components/layout";
import {
    AwaitingDocumentsPanel,
    InvalidInsurancePanel,
} from "pages/licence-checking/grey-fleet/check/panel";
import {
    GreyFleetCheckCoverRecords,
    hasRequiredCoverTypes,
} from "./GreyFleetCheckCoverRecords";
import PropTypes from "prop-types";

const defaultArray = [];

export function GreyFleetCheckInsuranceOverview({
    isLoading,
    checkData,
    evaluateStatus,
    reloadCheck,
    coverTypes = defaultArray,
}) {
    function isEmailSentRecently() {
        if (!checkData.insurance.emailLastSentDate) return true;
        const sentDate = new Date(checkData.insurance.emailLastSentDate);
        const now = new Date();
        const diffMs = now.getTime() - sentDate.getTime();
        return diffMs <= 24 * 60 * 60 * 1000;
    }

    return (
        <div className="spacer-bottom">
            <h2>Insurance Check</h2>
            <GridLayout numberOfColumns={4} gap={30}>
                <DataDisplayRecord
                    header="Insurance Status"
                    data={evaluateStatus(
                        checkData?.insurance?.status,
                        checkData?.insurance?.statusKey,
                        checkData?.insurance?.result,
                        ["INSURANCEEXPIRED", "INSURANCEFAILURE"]
                    )}
                    loading={isLoading}
                />
                <ShowHide
                    evaluator={hasRequiredCoverTypes(
                        checkData?.insurance,
                        coverTypes
                    )}
                    show={
                        <GreyFleetCheckCoverRecords
                            isLoading={isLoading}
                            insurance={checkData?.insurance}
                            coverTypes={coverTypes}
                        />
                    }
                />
            </GridLayout>
            <ShowHide
                evaluator={
                    !isLoading &&
                    checkData.insurance.statusKey === "COMPLETED" &&
                    checkData.failures.includes("INSURANCEFAILURE")
                }
                show={
                    <InvalidInsurancePanel
                        checkData={checkData}
                        reloadCheck={reloadCheck}
                    />
                }
            />
            <ShowHide
                evaluator={
                    !isLoading &&
                    checkData.insurance.statusKey === "AWAITINGRESPONSE" &&
                    isEmailSentRecently()
                }
                show={
                    <AwaitingDocumentsPanel
                        checkData={checkData}
                        reloadCheck={reloadCheck}
                    />
                }
            />
        </div>
    );
}

GreyFleetCheckInsuranceOverview.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    checkData: PropTypes.object.isRequired,
    evaluateStatus: PropTypes.func.isRequired,
    reloadCheck: PropTypes.func.isRequired,
    coverTypes: PropTypes.array,
};
